import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FormAnalyticsComponent } from './form-analytics/form-analytics.component';
import { GroupAnalyticsComponent } from './group-analytics/group-analytics.component';
import { SortByIndex } from './sortByIndex.pipe';
import { NgApexchartsModule } from "ng-apexcharts";
import { CountUpModule } from 'ngx-countup';



@NgModule({
  declarations: [
    BreadcrumbsComponent,
    FormAnalyticsComponent,
    GroupAnalyticsComponent,
    SortByIndex
  ],
  imports: [
    CommonModule,
    NgApexchartsModule,
    CountUpModule,
    TooltipModule.forRoot(),
  ],
  exports: [
    BreadcrumbsComponent,
    FormAnalyticsComponent,
    GroupAnalyticsComponent,
    SortByIndex
  ]
})
export class SharedModule { }
